<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/cms/plan/page" getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('jihuakaishishijian')">
            <yi_time_input type="daterange" format="yyyy-MM-dd HH:mm:ss" :start.sync="yt.conditions.planStartTimeStart" :end.sync="yt.conditions.planStartTimeEnd" :clearable="false"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_cross_select :component="'web_base_equipment_list'" :ids.sync="yt.conditions.equipmentIds"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('shengchanjihuadanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('zhuangtai')">
            <yi_dictionary_select :type="'EQUIPMENT_CMS_PLAN_STATUS'" :ids.sync="yt.conditions.status"></yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="clear()">{{ $t('chongzhi') }}</el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button
          v-if="utils.checkPower('web_equipment_cms_plan_list_add')"
          size="mini"
          @click="
            yt.showEditDialog('xinzeng', null);
            setDefaultValue();
          "
          type="primary"
          v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '生产计划-新增' } }"
        >
          {{ $t('xinzeng') }}
        </el-button>
        <el-button size="mini" @click="yt.showEditDialog('daoru', null, '1400px')" v-if="utils.checkPower('web_equipment_cms_plan_list_import')" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '生产计划-导入' } }">
          {{ $t('daoru') }}
        </el-button>
        <el-button size="mini" type="primary" :loading="yt.editObj.loading" :disabled="batchDeletDisabled" slot="reference" style="margin-left: 10px" v-if="utils.checkPower('web_equipment_cms_plan_list_issued')" @click="batchIssued()" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '生产计划-批量下发' } }">{{ $t('批量下发') }}</el-button>
        <el-button size="mini" type="primary" :loading="yt.editObj.loading" :disabled="batchDeletDisabled" slot="reference" style="margin-left: 10px" v-if="utils.checkPower('web_equipment_cms_plan_list_archive')" @click="batchArchive()" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '生产计划-批量归档' } }">{{ $t('批量归档') }}</el-button>
        <el-popconfirm title="是否确认批量删除?" confirm-button-text="是" cancelButtonText="否" @confirm="batchDelete()" v-if="utils.checkPower('web_equipment_cms_plan_list_batchDelete')">
          <el-button size="mini" type="primary" :disabled="batchDeletDisabled" slot="reference" style="margin-left: 10px" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '生产计划-批量删除' } }">{{ $t('piliangshanchu') }}</el-button>
        </el-popconfirm>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 操作列 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="(scope.row.status == 'Wait' || scope.row.status == 'Pause' || scope.row.status == 'Production') && utils.checkPower('web_equipment_cms_plan_list_update')">
            <el-button type="text" @click.native.stop="yt.showEditDialog('bianji', scope.row)">{{ $t('bianji') }}</el-button>
          </el-col>
          <el-col :span="0.1">
            <el-popconfirm title="是否确认删除?" confirm-button-text="是" cancelButtonText="否" @confirm="deletePlan(scope.row)" v-if="scope.row.status == 'Wait' || scope.row.status == 'Pause' || scope.row.status == 'Production'">
              <el-button type="text" slot="reference" v-if="(scope.row.status == 'Wait' || scope.row.status == 'Pause' || scope.row.status == 'Production') && utils.checkPower('web_equipment_cms_plan_list_delete')">{{ $t('shanchu') }}</el-button>
            </el-popconfirm>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.status == 'Wait' && utils.checkPower('web_equipment_cms_plan_list_issued')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '生产计划-下发工单' } }">
            <el-button :loading="yt.editObj.loading" type="text" @click.native.stop="issued(scope.row)">{{ $t('下发工单') }}</el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增/编辑表单 -->
      <template v-if="yt.editObj.action == 'xinzeng' || yt.editObj.action == 'bianji'">
        <div class="dialog-scroller-form">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('shengchanjihuadanhao')" required>
              <el-input v-model="yt.editObj.no" :disabled="yt.editObj.action == 'bianji'"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shebeimingcheng')" required>
              <yi_cross_select :max="1" :component="'web_base_equipment_list'" :ids.sync="yt.editObj.equipmentId"></yi_cross_select>
            </el-form-item>
            <el-form-item :label="$t('mojubianhao')" required>
              <div style="display: flex;">
                <el-input v-model="yt.editObj.mouldCode"></el-input>
                <yi_cross_select :isButton="true" :selectTitle="'code,name'" :component="'web_base_mould_list'" :max="1" :ids.sync="yt.editObj.mouldId" @getItems="getItem"> </yi_cross_select>
              </div>
            </el-form-item>
            <el-form-item :label="$t('gongyibianhao')">
              <!-- <el-input v-model="yt.editObj.craftCode"></el-input> -->
              <el-select v-model="yt.editObj.craftCode" filterable>
                <el-option v-for="item in mouldNoInfoList" :key="item.id" :label="item.mouldNo" :value="item.mouldNo"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('chanpinbianhao')">
              <el-input v-model="yt.editObj.materialCode"></el-input>
            </el-form-item>
            <el-form-item :label="$t('cailiao')">
              <el-input v-model="yt.editObj.material"></el-input>
            </el-form-item>
            <el-form-item :label="$t('chanpinmingcheng')">
              <el-input v-model="yt.editObj.materialName"></el-input>
            </el-form-item>
            <el-form-item :label="$t('guigexinghao')">
              <el-input v-model="yt.editObj.spec"></el-input>
            </el-form-item>
            <el-form-item :label="$t('yanse')">
              <el-input v-model="yt.editObj.color"></el-input>
            </el-form-item>
            <el-form-item :label="$t('pihao')">
              <el-input v-model="yt.editObj.batchNo"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jihuadanzhuangtai')" required>
              <yi_dictionary_select :type="'EQUIPMENT_CMS_PLAN_STATUS'" :ids.sync="yt.editObj.status" :disabled="yt.editObj.action == 'bianji'"></yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('jihuashuliang')" required>
              <el-input-number size="small" v-model="yt.editObj.planQuantity" :precision="0" :step="1" :min="1"></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('wanchengshuliang')">
              <el-input-number size="small" v-model="yt.editObj.finishQuantity" :step-strictly="true" :precision="0" :step="1" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('feipinshuliang')">
              <el-input-number size="small" v-model="yt.editObj.badQuantity" :step-strictly="true" :precision="0" :step="1" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('jihuakaishishijian')" required>
              <yi_time_input type="datetime" format="yyyy-MM-dd HH:mm:ss" :time.sync="yt.editObj.planStartTime"></yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('jihuawanchengshijian')" required>
              <yi_time_input type="datetime" format="yyyy-MM-dd HH:mm:ss" :time.sync="yt.editObj.planEndTime"></yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('beizhu')">
              <el-input maxlength="255" type="textarea" v-model="yt.editObj.remark"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="save()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <template v-if="yt.editObj.action == 'daoru'">
        <div class="dialog-scroller">
          <yi_excel_import ref="cmsPlanOrderImport" @loading-start="startLoading" @loading-stop="stopLoading" :templatekey="'cms_plan_import_template_key'" :uploadApi="'/web/cms/plan/batchImport'" />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="default" size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button type="primary" size="mini" :loading="mainSubImportLoading" @click="mainSubImportData">{{ $t('baocun') }}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
const date = new Date();
const begin = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0).getTime();
const end = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59).getTime();

export default {
  name: 'web_equipment_cms_plan_list',
  data() {
    return {
      mouldNoInfoList: [],
      mainSubImportLoading: false,
      selected: [],
      batchDeletDisabled: true,
      columns: [
        {
          label: 'xuanze',
          type: 'selection',
          selectable: (row, index) => {
            return row.status !== 'File';
          },
          width: 30
        },
        {
          label: 'shengchanjihuadanhao',
          prop: 'no',
          width: 130
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name',
          width: 130
        },
        {
          label: 'mojubianhao',
          prop: 'mouldCode',
          width: 130
        },
        {
          label: 'gongyibianhao',
          prop: 'craftCode',
          width: 130
        },
        {
          label: 'chanpinbianhao',
          prop: 'materialCode',
          width: 130
        },
        {
          label: 'cailiao',
          prop: 'material',
          width: 130
        },
        {
          label: 'chanpinmingcheng',
          prop: 'materialName',
          width: 130
        },
        {
          label: 'guigexinghao',
          prop: 'spec',
          width: 130
        },
        {
          label: 'yanse',
          prop: 'color',
          width: 130
        },
        {
          label: 'pihao',
          prop: 'batchNo',
          width: 130
        },
        {
          label: 'jihuadanzhuangtai',
          prop: 'status',
          type: 'dictionary_tag',
          key: 'EQUIPMENT_CMS_PLAN_STATUS',
          width: 100
        },
        {
          label: 'jihuashuliang',
          prop: 'planQuantity'
        },
        {
          label: 'wanchengshuliang',
          prop: 'finishQuantity'
        },
        {
          label: 'feipinshuliang',
          prop: 'badQuantity'
        },
        {
          label: 'jihuakaishishijian',
          prop: 'planStartTime',
          type: 'time',
          width: 150,
          format: 'YYYY-MM-DD'
        },
        {
          label: 'jihuajieshushijian',
          prop: 'planEndTime',
          type: 'time',
          width: 150,
          format: 'YYYY-MM-DD'
        },
        {
          label: 'beizhu',
          prop: 'remark',
          width: 130
        },
        {
          label: 'caozuo',
          type: 'slot',
          fixed: 'right',
          width: 200
        }
      ]
    };
  },
  watch: {
    'yt.editObj.equipmentId': function(newVal, oldVal) {
      // 在这里调用你的请求函数
      this.getMouldInfoList(newVal);
    }
  },
  created() {
    setTimeout(() => {
      this.setDefaultTime();
      this.yt.get(1);
    }, 300);
  },
  methods: {
    getItem(e) {
      console.log(e);
      this.yt.editObj.mouldCode = e.code;
    },
    getMouldInfoList(equipmentId) {
      if (!equipmentId) {
        return;
      }
      this.mouldNoInfoList = [];
      this.http
        .get('/web/equipment/archives/mould/no/info/list?equipmentId=' + this.yt.editObj.equipmentId)
        .then(res => {
          // this.$message.success(this.$t(res.msg));
          this.mouldNoInfoList = res.data;
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    setDefaultValue() {
      if (this.yt.editObj.action === 'xinzeng') {
        this.yt.editObj.status = 'Wait';
        this.yt.editObj.finishQuantity = 0;
        this.yt.editObj.badQuantity = 0;
      }
    },
    setDefaultTime() {
      this.yt.conditions.planStartTimeStart = begin;
      this.yt.conditions.planStartTimeEnd = end;
    },
    clear() {
      this.yt.conditions = {
        planStartTimeStart: begin,
        planStartTimeEnd: end
      };
      this.setDefaultTime();
      this.yt.get(1);
    },
    save() {
      if (this.yt.editObj.planStartTime && this.yt.editObj.planEndTime && this.yt.editObj.planStartTime >= this.yt.editObj.planEndTime) {
        this.$message.error(this.$t('jihuawanchengshijianbunengxiaoyujihuakaishishijian'));
        return;
      }
      if (this.yt.editObj.action == 'xinzeng') {
        this.yt.req('POST', '/web/cms/plan/create');
      }
      if (this.yt.editObj.action == 'bianji') {
        this.yt.req('POST', '/web/cms/plan/update');
      }
    },
    exportExcel() {
      let params = this.yt.conditions;
      return this.http
        .get('/web/report/export/equipment_cms_plan_export', { params })
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    selectionChange(items) {
      this.selectIds = items.map(item => {
        return item.id;
      });
      if (this.selectIds.length > 0) {
        this.batchDeletDisabled = false;
      } else {
        this.batchDeletDisabled = true;
      }
    },
    deletePlan(data) {
      this.http
        .post('web/cms/plan/delete', data)
        .then(res => {
          this.$message({
            message: this.$t('success'),
            type: 'success'
          });
          this.selectIds = [];
          this.yt.get(1);
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    batchDelete() {
      if (this.selectIds.length === 0) {
        this.$message({
          message: this.$t('qinggouxuanshuju'),
          type: 'error'
        });
        return;
      }
      this.http
        .post('web/cms/plan/batchDelete', this.selectIds)
        .then(res => {
          this.$message({
            message: this.$t('success'),
            type: 'success'
          });
          this.selectIds = [];
          this.yt.get(1);
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    startLoading() {
      this.mainSubImportLoading = true;
    },
    stopLoading() {
      this.mainSubImportLoading = false;
    },
    mainSubImportData() {
      let data = [...this.$refs.cmsPlanOrderImport.tableData];
      if (data.length <= 0) {
        this.$message.error(this.$t('qingshangchuanwenjian'));
        return;
      }
      if (this.$refs.cmsPlanOrderImport.listLength == null || this.$refs.cmsPlanOrderImport.listLength.length == 0) {
        this.mainSubImportLoading = true;
        return this.http
          .post('/web/cms/plan/batchImport?onlyValidate=false', data)
          .then(response => {
            this.utils.successMessage(this.$t(response.msg));
            this.yt.isShowEditDialog = false;
            this.yt.get(1);
          })
          .catch(err => {
            this.utils.errorMessage(this.$t(err));
          })
          .finally(() => {
            this.mainSubImportLoading = false;
          });
      } else {
        this.utils.errorMessage(this.$t('daoruxinxiyouwu'));
      }
    },
    issued(row) {
      let ids = [];
      ids.push(row.id);
      this.yt.editObj.loading = true;
      this.$message({
        message: '下发中请等待',
        type: 'warning',
        duration: 3 * 1000
      });
      this.http
        .post('/web/cms/plan/issued', ids)
        .then(res => {
          let count = 1;
          let timer = setInterval(() => {
            if (count > 3) {
              this.$message.error(this.$t('下发响应已经超时，请去下发记录确认最终结果'));
              clearInterval(timer);
              this.yt.editObj.loading = false;
            }
            this.http.get('/web/gateway/sendRecord/page', { params: { planId: row.id, orderBy: 'issuedTime desc' } }).then(res => {
              if (res.data.total > 0) {
                let record = res.data.rows[0];
                if (record.issuedStatus == '2') {
                  this.$message.success(this.$t('下发成功'));
                  clearInterval(timer);
                  this.yt.editObj.loading = false;
                }
              }
            });
            count++;
          }, 3 * 1000);
        })
        .catch(err => {
          this.utils.errorMessage(this.$t(err));
        });
    },
    batchIssued() {
      if (this.selectIds.length === 0) {
        this.$message({
          message: this.$t('qinggouxuanshuju'),
          type: 'error'
        });
        return;
      }
      this.http
        .post('/web/cms/plan/issued', this.selectIds)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.selectIds = [];
          this.yt.get(1);
        })
        .catch(err => {
          this.utils.errorMessage(this.$t(err));
        })
        .finally(() => {
          this.yt.editObj.loading = false;
        });
    },

    batchArchive() {
      if (this.selectIds.length === 0) {
        this.$message({
          message: this.$t('qinggouxuanshuju'),
          type: 'error'
        });
        return;
      }
      this.http
        .post('/web/cms/plan/archive', this.selectIds)
        .then(res => {
          this.utils.successMessage('归档指令已经下发');
          this.selectIds = [];
          this.yt.get(1);
        })
        .catch(err => {
          this.utils.errorMessage(this.$t(err));
        })
        .finally(() => {
          this.yt.editObj.loading = false;
        });
    }
  }
};
</script>

<style scoped></style>
